module.exports = __webpack_public_path__ + "img/Kiribati.ac793c98.svg";